module.exports = __webpack_public_path__ + "img/fondo-cta-empresas-mobile.a19ae15.webp";